// import alerts from '@/alerts/alert'
// import AuthenticationService from '@/services/AuthenticationService'
// import store from '@/store'

const home = {
  namespaced: true,
  state: {
    menus: [
      {
        title: 'Home',
        url: '#Home',
        key: 'Home',
        icon: 'home',
        class: 'active'
      },
      {
        title: 'Products',
        url: '#Products',
        key: 'Products',
        icon: 'gift-outline',
        class: ''
      },
      {
        title: 'Manfaat',
        url: '#Manfaat',
        key: 'Manfaat',
        icon: 'thumb-up-outline',
        class: ''
      },
      {
        title: 'Testimoni',
        url: '#Testimoni',
        key: 'Testimoni',
        icon: 'account-star-outline',
        class: ''
      },
      // {
      //   title: 'Customers',
      //   url: '#Customers',
      //   key: 'Customers',
      //   icon: 'account-group-outline',
      //   class: ''
      // },
      {
        title: 'Pricing',
        url: '#Pricing',
        key: 'Pricing',
        icon: 'cash',
        class: ''
      }
      // {
      //   title: 'Blog',
      //   url: '#Blog',
      //   key: 'Blog',
      //   icon: 'earth',
      //   class: ''
      // }
    ]
  }
}

export default home
